import { render, staticRenderFns } from "./AnchorCommunicationModal.vue?vue&type=template&id=71bc9de1&scoped=true&"
import script from "./AnchorCommunicationModal.vue?vue&type=script&lang=js&"
export * from "./AnchorCommunicationModal.vue?vue&type=script&lang=js&"
import style0 from "./AnchorCommunicationModal.vue?vue&type=style&index=0&id=71bc9de1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bc9de1",
  null
  
)

export default component.exports